import {Button} from "@mui/material";
import type {ButtonProps} from "@mui/material/Button";

const CancelButton = (props: ButtonProps) => {
    const {sx, ...rest} = props;

    const baseSx = {
        "&.MuiButton-root": {
            width: "auto",
            minWidth: "140px",
            minHeight: "48px",
            backgroundColor: "transparent",
            color: "var(--an-ink)",
            fontFamily: "'Lato', system-ui, sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: 1,
            textTransform: "none",
            border: "2px solid var(--an-ink)",
            borderRadius: "4px",
            paddingLeft: "24px",
            paddingRight: "24px",
            "&:hover": {backgroundColor: "rgba(0,0,0,0.04)", borderColor: "var(--an-ink)"},
        },
    };

    return (
        <Button
            variant="outlined"
            sx={[
                baseSx,
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
            {...rest}
        />
    );
};

export default CancelButton;
